exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".VetCheckSendHistory__root{overflow-x:scroll;height:100%;position:relative;-ms-flex:1;flex:1}\n", "", {"version":3,"sources":["/home/runner/work/greenline-web/greenline-web/web/js/components/vetcheck/pages/VetCheckSendHistory.scss"],"names":[],"mappings":"AAAA,2BAAM,kBAAkB,YAAY,kBAAkB,WAAW,MAAM,CAAC","file":"VetCheckSendHistory.scss","sourcesContent":[".root{overflow-x:scroll;height:100%;position:relative;-ms-flex:1;flex:1}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "VetCheckSendHistory__root"
};